import { BaseMeasures } from './BaseMeasures.ts';

export const ExperienceActionMeasures: BaseMeasures = new BaseMeasures();
